<template>
    <div class="page container-fluid container-table">
        <particles-bg type="cobweb" :bg="true" num=200 color="#303030" />
        <div class="row vertical-center-row text-center">
            <div class="card-deck col-sm-8 mx-auto">
                <div class="card box-neon">
                    <div class="card-body">
                        <div class="text-light">
                            <div class="row" v-for="(part, key) in parts" v-bind:key="key">
                                <p class="text-left col-9">
                                    <a href="#" v-on:click="loadProducts(part.key, part)" class="text-light"><img :src="getPartImage(part.key)" :alt="part.name" class="pr-1"> {{ part.name }}</a>
                                </p>
                                <p class="text-left col-3">$ {{ part.price }}</p>
                            </div>
                            <div class="row">
                                <div class="col-12"><hr class="bg-light mt-0"></div>
                            </div>
                            <div class="row">
                                <p class="text-left col-9">
                                    <a href="#" class="text-light"> Ver Resumen</a>
                                </p>
                                <p class="text-left col-3">$ {{ total }}</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card box-neon">
                    <div class="card-body">
                        <div class="text-light">
                            <div class="row">
                                <div class="col-12">
                                    <div class="row pb-2">
                                        <div class="col-10 text-left pt-1">Seleccionar: {{ actualPart.name }}</div>
                                        <div class="col-2"><img :src="getPartImage(actualPart.key)" :alt="actualPart.name"></div>
                                    </div>
                                    <hr class="bg-light mt-0">
                                    <div class="row" v-for="(product, key) in products" v-bind:key="key">
                                        <p class="text-left col-9"><a href="#" v-on:click="selectProduct(actualPart.key, product, key)" class="text-light">{{ product.name }}</a></p> <p class="text-left col-3">$ {{ product.price }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Advanced',
  data() {
      return {
          parts: null,
          actualPart: {
              key: '',
              name: ''
          },
          products: null,
          total: null
      }
  },
  methods: {
        getPartImage(part) {
            return '/assets/icons/' + part + '.png'
        },
        loadParts() {
            const parts = {
                0: {
                    key: 'processor',
                    name: 'Procesador',
                    price: '0'
                },
                1: {
                    key: 'motherboard',
                    name: 'Tarjeta Madre',
                    price: '0'
                },
                2: {
                    key: 'memory',
                    name: 'Memoria',
                    price: '0'
                },
                3: {
                    key: 'storage',
                    name: 'Almacenamiento',
                    price: '0'
                },
                4: {
                    key: 'videocard',
                    name: 'Tarjeta de Video',
                    price: '0'
                },
                5: {
                    key: 'cabinet',
                    name: 'Gabinete',
                    price: '0'
                },
                6: {
                    key: 'electrical',
                    name: 'Fuente de Poder',
                    price: '0'
                }
            }

            this.parts = parts
        },
        loadProducts(key, part) {
            this.actualPart.key = key
            this.actualPart.name = part.name
            
            const products = {
                processor: {
                    0: {
                        name: 'AMD Ryzen 5 3600XT',
                        price: 6989,
                        model: 'PRAM4AMDRY5360XT'
                    },
                    1: {
                        name: 'AMD Ryzen 7 3700X',
                        price: 9192,
                        model: 'PRAM4AMDRY73700X'
                    },
                    2: {
                        name: 'AMD Ryzen 9 3900X',
                        price: 13091,
                        model: 'PRAM4AMDRY93900X'
                    },
                    3: {
                        name: 'Intel Core i3 9100F',
                        price: 1982,
                        model: 'PR151INTI39100F'
                    },
                    4: {
                        name: 'Intel Core i5 9600K',
                        price: 6248,
                        model: 'PR151INTI59600K'
                    },
                    5: {
                        name: 'Intel Core i7 7740X',
                        price: 9290,
                        model: 'PR206INTI77740X'
                    }
                }
            }

            this.products = products[key]
        },
        selectProduct(part, product) {
            this.parts[part].name = product.name
            this.parts[part].price = (product.price).toString()

            console.log(this.total)
        },
    },
    created() {
        this.total = '0'
        this.loadParts()

        const _total = JSON.parse('[]')
        for(const [key, part] in this.parts) {
            _total.push({key: key, price: part.price})
        }
        console.log(_total)
        //this.total = JSON.stringify(_total)
    },
}
</script>

<style>

.card-deck, .card, .list-group, .list-group-item, product {
    background-color: #191919;
    border: none;
}

</style>